import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const BrandContext = createContext(null);

export const useBrand = () => {
  const context = useContext(BrandContext);
  if (!context) {
    throw new Error('useBrand must be used within BrandProvider');
  }
  return context;
};

export const BrandProvider = ({ customer, children }) => {
  const [brandColor, setBrandColor] = useState(customer?.primary_color || '#2563EB');

  useEffect(() => {
    if (customer?.primary_color) {
      setBrandColor(customer.primary_color);
      document.documentElement.style.setProperty('--brand-color', customer.primary_color);
    }
  }, [customer]);

  const value = useMemo(() => ({ brandColor, customer }), [brandColor, customer]);

  return (
    <BrandContext.Provider value={value}>
      {children}
    </BrandContext.Provider>
  );
};
